module.exports = __webpack_public_path__ + "img/3.78557dce.png";